import React, { memo, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './css/ArticleThumbnail6.css';
import { getFullDateStringFromDate, getLocalTimeFromDatabaseTime } from '../../../../catalog/DateTime';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';

const ArticleThumbnail6 = (props) => {
    const { article, darkBackground } = props;
    const { globalState } = useContext(context);

    const getTitle = (title) => {
        if (title.length > 40) {
            return `${title.substr(0, 45)}...`;
        }
        return title;
    };

    return (
        <NavLink to={`/articles/${article.id}`} className={darkBackground ? 'article-thumbnail6-container text-left-align full-width bg-lightsilver text-black text-no-underline' : 'article-thumbnail6-container text-left-align full-width bg-white text-black text-no-underline'}>
            <div className="article-thumbnail6 p-l-30px p-r-20px">
                <p className="article-thumbnail6-date alegreya-font-family font-weight-300 font-spacing-wider m-t-5px m-b-5px font-size-s">{getFullDateStringFromDate(getLocalTimeFromDatabaseTime(isValidObject(article.timeOfArticle) ? article.timeOfArticle : article.timeCreated))}</p>
                <p className="article-thumbnail6-content alegreya-font-family font-weight-500 font-spacing-wider m-t-0 m-b-0 font-size-xl">{getTitle(article.title)}</p>
                <p className="article-thumbnail6-author alegreya-font-family font-weight-300 font-spacing-wider m-t-5px m-b-5px font-size-xs">{isValidString(article.author) ? `By: ${article.author}` : `By: ${globalState.teamAlias}`}</p>
            </div>
        </NavLink>
    );
};

ArticleThumbnail6.propTypes = {
    article: PropTypes.object.isRequired,
    darkBackground: PropTypes.bool.isRequired,
};

export default memo(ArticleThumbnail6);
